import { t } from '@/features/i18n/utils';
import { getDefaultStore } from 'jotai';
import { insightsMineAtom } from '@/features/insights/store';
import { insightsQuery } from '@/features/insights/queries';
import { createFileRoute } from '@tanstack/react-router';
import { ProjectBreadcrumbs } from '@/features/projects/components/project-breadcrumbs';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Main, MainPending } from '@/ui/components/main';
import { InsightsPage } from '@/features/insights/components/insights-page';

export const Route = createFileRoute('/_authed/project/$projectId/insights')({
  component: RouteComponent,
  loader: ({ context, params }) =>
    context.queryClient.infiniteQuery({
      ...insightsQuery({
        projectId: params.projectId,
        savedBy: getDefaultStore().get(insightsMineAtom) ? context.auth.user.id : undefined,
      }),
      staleTime: 'static',
    }),
  pendingComponent: MainPending,
});
function RouteComponent() {
  return (
    <Main>
      <Header>
        <HeaderBackButton />
        <ProjectBreadcrumbs>
          <BreadcrumbPage>{t({ en: 'Saved findings', nb: 'Lagrede funn' })}</BreadcrumbPage>
        </ProjectBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <InsightsPage />
    </Main>
  );
}
